var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.083 33.333q-1 0-1.708-.708t-.708-1.708V9.083q0-1 .708-1.708t1.708-.708h21.834q1 0 1.708.708t.708 1.708v21.834q0 1-.708 1.708t-1.708.708Zm0-1.416h10.209V8.083H9.083q-.375 0-.687.313-.313.312-.313.687v21.834q0 .375.313.687.312.313.687.313Zm11.625 0h10.209q.375 0 .687-.313.313-.312.313-.687V20H20.708Zm0-13.334h11.209v-9.5q0-.375-.313-.687-.312-.313-.687-.313H20.708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.d10f12a7718674e4ccba876f5352a6b9.svg";
export { ForwardRef as ReactComponent };